import React from 'react';
import Navbar from '../Components/Navbar';
import "../Components/CSS/Content.css"

import ProblemList from '../Components/ProblemList';

import {v4 as uuidv4} from 'uuid'

import { useState, useEffect } from 'react';
import { baseURL } from '../Config/settings';
import { useNavigate } from 'react-router-dom';

import Loading from '../Loading';

const colorMapping = {
  "EASY": "#76E744",
  "MEDIUM": "#51ADEF",
  "HARD": "red",
}

const Content = () => {

  let navigate = useNavigate()

  const [problems, setProblems] = useState(null)
  const [problemType, setProblemType] = useState('ALL')
  const [tags, setTags] = useState(null)
  const [checkState, setCheckState] = useState(null)
  const [loading, setLoading] = useState({tags: true, problems: true})

  useEffect(() => {
    setLoading({tags: true, problems: true})
    fetch(`${baseURL}/problems/all`)
    .then(res => res.json())
    .then(data => setProblems(data))
    .then(() => setLoading(loading =>  {return {...loading, problems: false}}))

    fetch(`${baseURL}/problems/tags`)
    .then(res => res.json())
    .then(data => {
      const ans = data.map(elem => elem.tag)
      const trueArray = new Array(ans.length).fill(true)
      setCheckState(trueArray)
      setTags(ans)
      setLoading(loading => { return {...loading, tags: false}})
    })
  }, [])

  const handleProblemTypeChange = (e) => {
    setProblemType(e.target.value)
  }

  const handleCheckChange = (position) => {
    const updatedCheckedState = checkState.map((item, index) =>
    index === position ? !item : item)

    setCheckState(updatedCheckedState)
  }

  const getCorrectProblems = () => {
    if(problems === null) {
      return null
    }

    if(problemType === "ALL") {
      return problems
    }

    const renderProblems = problems.filter((problem) => {
      if(problem.difficulty === problemType)
      {
        return true
      }
      return false
    })
    return renderProblems
  }

  const checkedProblems = () => {
    if(problems === null) {
      return null
    }
    const baseProblems = getCorrectProblems()
    const requiredTypes = new Set()
    if(tags === null) {
      return null
    }

    for(let i = 0; i < tags.length; i++) {
      if(checkState[i] === true) {
        requiredTypes.add(tags[i].toLowerCase())
      }
    }
    
    const requiredProblems = baseProblems.filter((problem) => {
      for(let i = 0; i < problem.tags.length; i++) {
        const lowerCase = problem.tags[i].toLowerCase()
        if(requiredTypes.has(lowerCase)) {
          return true
        }
      }
      return false
    })

    return requiredProblems
  }

  const setAllTagsState = (value) => {
    const arr = new Array(checkState.length).fill(value);
    setCheckState(arr);
  }

  const returnLoadedContents = () => {
    return (<>
            <div className='main-content-div'>
          <span style={{color: 'black'}}>Select the correct difficulty for your practice</span>
          {problemType === "ALL" ?<span className='difficulty-button difficulty-button-border' style={{background: 'orange'}} onClick={() => setProblemType('ALL')}>ALL</span> : <span className='difficulty-button' style={{background: 'orange'}} onClick={() => setProblemType('ALL')}>ALL</span>}
          {problemType === "EASY" ? <span className='difficulty-button difficulty-button-border'  style={{background: colorMapping['EASY']}} onClick={() => setProblemType('EASY')}>EASY</span>: <span className='difficulty-button'  style={{background: colorMapping['EASY']}} onClick={() => setProblemType('EASY')}>EASY</span>}
          {problemType === "MEDIUM" ? <span className='difficulty-button difficulty-button-border' style={{background: colorMapping['MEDIUM']}} onClick={() => setProblemType('MEDIUM')}>MEDIUM</span>: <span className='difficulty-button' style={{background: colorMapping['MEDIUM']}} onClick={() => setProblemType('MEDIUM')}>MEDIUM</span>}
          {problemType === "HARD"  ? <span className='difficulty-button difficulty-button-border hard' style={{background: colorMapping['HARD']}} onClick={() => setProblemType('HARD')}>HARD</span> : <span className='difficulty-button hard' style={{background: colorMapping['HARD']}} onClick={() => setProblemType('HARD')}>HARD</span>}
        </div>
        <hr />
        {loading.tags === false ? <div className='justification-content' style={{display: 'flex', paddingLeft: '25px', paddingRight: '25px', paddingTop: '5px', paddingBottom: '5px'}}>
          <div className='filter-choice'>
            <span style={{color: 'black'}}>Select the Question Type</span>
            <div className='mobile-div'>
              <span className='toggle-all-tags'
            onClick={() =>  setAllTagsState(true)}
            >Select All</span>
            <span className='toggle-all-tags'
            onClick={() => setAllTagsState(false)}>Clear All</span>
            </div>
          </div>
          <div className='checkbox-container'>
            {(tags.map((tag, idx) => <div key={uuidv4()} style={{color: "black", display: "inline-block"}}>
          <label style={{ margin: "20px"}}><input key={uuidv4()} type={"checkbox"} name={tag} value={tag} checked={checkState[idx]} onChange={() => handleCheckChange(idx)}></input>{tag}</label>
        </div>))}
          </div>
          </div>: <Loading></Loading>}
        <hr />
        {problems !== null && checkedProblems() !== null ? <ProblemList problems={checkedProblems()}></ProblemList>: <Loading />}
    </>)
  }

  return (
      <div style={{height: "100%", display: "flex", flexDirection: "column"}}>
      <div className='content'>
          <Navbar></Navbar>
      </div>
      <div style={{height: '100%', textAlign: 'center', justifySelf: 'center'}}>
        { loading.problems === false && loading.tags === false ? returnLoadedContents() : <div style={{height: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center'}}><Loading></Loading></div>}
      </div>
      </div>
  )
};

export default Content;
